import { Component, JSX } from "solid-js";

export type KbdVariant = "default" | "inverse" | "bare" | "bare-inverse";

export interface KbdProps {
  children: JSX.Element;
  /**
   * default: chip on a light ground; inverse: chip on ink;
   * bare: hint text on a light ground; bare-inverse: hint text on ink.
   */
  variant?: KbdVariant;
  class?: string;
  "aria-hidden"?: "true";
}

// Each variant carries its own font size: a caller-supplied `class` is
// concatenated after these, and two font-size utilities on one element resolve
// by generated-CSS order rather than class-string order.
const variantClasses: Record<KbdVariant, string> = {
  default: "px-1 border border-line bg-surface text-ink-3 text-[10px]",
  inverse: "px-1 border border-paper/30 text-paper/80 text-[10px]",
  bare: "text-ink-3 text-[9.5px]",
  "bare-inverse": "text-paper/70 text-[9.5px]",
};

export const Kbd: Component<KbdProps> = (props) => (
  <kbd
    aria-hidden={props["aria-hidden"]}
    class={
      "inline-flex items-center h-4 rounded-sm font-mono leading-none " +
      variantClasses[props.variant ?? "default"] +
      " " +
      (props.class ?? "")
    }
  >
    {props.children}
  </kbd>
);
